'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var generateIdForFile = exports.generateIdForFile = function generateIdForFile(_ref) {
  var file = _ref.file,
      timestamp = _ref.timestamp;

  return file.name + '-' + timestamp;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/file-upload/util/generateIdForFile.js
// module id = 554
// module chunks = 2 3